import AppShell from "./framework/AppShell"

export default AppShell
